import Button from "@components/Button";
import { styled } from "solid-styled-components";

export const PlayButtonWrapper = styled(Button)<{ alt?: boolean }>`
  position: relative;
  overflow: hidden;
  font-size: ${({ diameter }) => `calc(${diameter} / 2)`};
  ${({ alt, theme }) =>
		alt
			? `background: none; color:${theme?.colors.accentTertiary};`
			: `&::after {
    content: '';
    position: absolute;
    background: #00000010;
    width: 100%;
    height: 100%;
    top: 50%;
    /* translate: 0 -50%; */
    pointer-events: none;
  }`}
`;
